/*
 * Globalize Culture es-ES
 *
 * http://github.com/jquery/globalize
 *
 * Copyright Software Freedom Conservancy, Inc.
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * This file was generated by the Globalize Culture Generator
 * Translation: bugs found in this file need to be fixed in the generator
 */

(function(window, undefined) {
    let Globalize;

    if (
        typeof require !== 'undefined' &&
        typeof exports !== 'undefined' &&
        typeof module !== 'undefined'
    ) {
        // Assume CommonJS
        Globalize = require('globalize');
    } else {
        // Global variable
        Globalize = window.Globalize;
    }

    Globalize.addCultureInfo('es-ES', 'default', {
        name: 'es-ES',
        englishName: 'Spanish (Spain, International Sort)',
        nativeName: 'Español (España, alfabetización internacional)',
        language: 'es',
        numberFormat: {
            ',': '.',
            '.': ',',
            NaN: 'NeuN',
            negativeInfinity: '-Infinito',
            positiveInfinity: 'Infinito',
            percent: {
                ',': '.',
                '.': ',',
            },
            currency: {
                pattern: ['-n $', 'n $'],
                ',': '.',
                '.': ',',
                symbol: '€',
            },
        },
        calendars: {
            standard: {
                firstDay: 1,
                days: {
                    names: [
                        'domingo',
                        'lunes',
                        'martes',
                        'miércoles',
                        'jueves',
                        'viernes',
                        'sábado',
                    ],
                    namesAbbr: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
                    namesShort: ['do', 'lu', 'ma', 'mi', 'ju', 'vi', 'sá'],
                },
                months: {
                    names: [
                        'enero',
                        'febrero',
                        'marzo',
                        'abril',
                        'mayo',
                        'junio',
                        'julio',
                        'agosto',
                        'septiembre',
                        'octubre',
                        'noviembre',
                        'diciembre',
                        '',
                    ],
                    namesAbbr: [
                        'ene',
                        'feb',
                        'mar',
                        'abr',
                        'may',
                        'jun',
                        'jul',
                        'ago',
                        'sep',
                        'oct',
                        'nov',
                        'dic',
                        '',
                    ],
                },
                AM: null,
                PM: null,
                eras: [{ name: 'd.C.', start: null, offset: 0 }],
                patterns: {
                    d: 'dd/MM/yyyy',
                    D: "dddd dd' de 'MMMM' de 'yyyy",
                    I: "dddd dd' de 'MMMM'",
                    t: 'H:mm',
                    T: 'H:mm:ss',
                    f: "dddd, dd' de 'MMMM' de 'yyyy H:mm",
                    F: "dddd, dd' de 'MMMM' de 'yyyy H:mm:ss",
                    M: 'dd MMMM',
                    Y: "MMMM' de 'yyyy",
                },
            },
        },
    });
})(this);
